export const getChatSessionKey = (isAuthenticated: boolean, productSlug: string) =>
  isAuthenticated ? `logged-in-${productSlug}` : `logged-out-${productSlug}`;
